import ButtonLink from "PFComponents/button/button_link";
import { Typography } from "PFComponents/typography";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React, { JSX } from "react";
import { useTranslation } from "react-i18next";

type DownloadLinkProps = {
  creationDate: Date;
  uri: string;
  isLatestVersion?: boolean;
  onClick?: () => void;
};

export const DownloadLink = ({
  creationDate,
  uri,
  isLatestVersion,
  onClick
}: DownloadLinkProps): JSX.Element => {
  const { formatDate } = useDateFormatter();
  const { t } = useTranslation("insights", { keyPrefix: "reports" });
  return (
    <ButtonLink href={uri} target="_blank" kind="blank" isExternalLink onClick={onClick}>
      <Typography variant="labelRegular">{formatDate(creationDate)}</Typography>
      {isLatestVersion && <Typography variant="labelRegular">{t("table.latestVersion")}</Typography>}
    </ButtonLink>
  );
};
